import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/react/24/outline';
import styles from './AdminProject.module.css';
import {adminProjectRequestListAPI} from "../../../services/admin";
import AdminProjectRequestInfo from "./AdminProjectRequestInfo";

interface AdminProjectProps {
    requestId: number;
}

//프로젝트 추가 요청 상세 페이지 버튼
const AdminProjectRequest: React.FC<AdminProjectProps> = ({requestId}) => {
    const navigate = useNavigate();
    const [projectRequestIds, setProjectRequestIds] = useState<number[]>([]);
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    useEffect(() => {
        const fetchProjects = async () => {
            try {
                //요청 식별자 목록 API
                const response = await adminProjectRequestListAPI();
                setProjectRequestIds(response);
                const index = response.findIndex(pid => pid === requestId);
                setCurrentIndex(index);
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        };

        fetchProjects();
    }, [requestId]);

    //이전 요청 페이지
    const handlePrevious = () => {
        if (currentIndex > 0) {
            const prevProjectRequestId = projectRequestIds[currentIndex - 1];
            navigate(`/admin/projects/request/${prevProjectRequestId}`);
        }
    };

    //다음 요청 페이지
    const handleNext = () => {
        if (currentIndex < projectRequestIds.length - 1) {
            const nextProjectRequestId = projectRequestIds[currentIndex + 1];
            navigate(`/admin/projects/request/${nextProjectRequestId}`);
        }
    };

    //요청 식별자가 없는 경우
    if (!requestId) {
        return <div>Invalid project request ID</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.navigationContainer}>
                {/*이전 요청 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === 0 ? styles.disabled : ''}`}
                    onClick={handlePrevious}
                    disabled={currentIndex === 0}
                    aria-label="Previous project"
                >
                    <ChevronLeftIcon className={styles.navIcon}/>
                </button>

                <div className={styles.contentWrapper}>
                    {/*프로젝트 추가 요청 정보*/}
                    <AdminProjectRequestInfo requestId={requestId}/>
                </div>

                {/*다음 요청 버튼*/}
                <button
                    className={`${styles.navButton} ${currentIndex === projectRequestIds.length - 1 ? styles.disabled : ''}`}
                    onClick={handleNext}
                    disabled={currentIndex === projectRequestIds.length - 1}
                    aria-label="Next project"
                >
                    <ChevronRightIcon className={styles.navIcon}/>
                </button>
            </div>
        </div>
    );
};

export default AdminProjectRequest;